import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function AdminPlans() {
  const [plans, setPlans] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/seat-plans").then((r) => setPlans(r.data.plans)); }, []);
  const set = (i, k, v) => setPlans(plans.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  const save = async () => {
    setBusy(true);
    try {
      if (plans.some((p) => p.min === "" || p.monthly === "" || Number(p.monthly) <= 0)) throw new Error("Fill in every minimum and a price above ₹0");
      const body = plans.map((p) => ({ ...p, min: parseInt(p.min, 10), max: p.max === "" || p.max == null ? null : parseInt(p.max, 10), monthly: parseFloat(p.monthly) }));
      const r = await api.put("/admin/seat-plans", { plans: body });
      setPlans(r.data.plans); toast.success("Pricing saved");
    } catch (e) { toast.error(e.response?.data?.detail || e.message || "Could not save"); } finally { setBusy(false); }
  };
  if (!plans) return <p className="text-sm text-stone-400">Loading…</p>;
  return (
    <div data-testid="admin-plans">
      <p className="mb-4 text-sm text-stone-400">Changes apply to new sign-ups and upgrades. Existing subscriptions keep their price until they change plan.</p>
      <div className="space-y-3">
        {plans.map((p, i) => (
          <div key={p.id} className="grid grid-cols-2 gap-3 rounded-2xl border border-white/10 bg-[#0b1322] p-4 sm:grid-cols-5" data-testid={`admin-plan-${p.id}`}>
            <label className="text-xs text-stone-400">Name<Input value={p.name} onChange={(e) => set(i, "name", e.target.value)} className="mt-1 bg-white/5 text-stone-100" data-testid={`admin-plan-name-${p.id}`} /></label>
            <label className="text-xs text-stone-400">Min employees<Input type="number" value={p.min} onChange={(e) => set(i, "min", e.target.value)} className="mt-1 bg-white/5 text-stone-100" data-testid={`admin-plan-min-${p.id}`} /></label>
            <label className="text-xs text-stone-400">Max employees{p.id === "enterprise" ? " (blank = no limit)" : ""}<Input type="number" value={p.max ?? ""} onChange={(e) => set(i, "max", e.target.value)} className="mt-1 bg-white/5 text-stone-100" data-testid={`admin-plan-max-${p.id}`} /></label>
            <label className="text-xs text-stone-400">₹ per employee / month<Input type="number" value={p.monthly} onChange={(e) => set(i, "monthly", e.target.value)} className="mt-1 bg-white/5 text-stone-100" data-testid={`admin-plan-price-${p.id}`} /></label>
            <div className="self-end text-xs text-stone-400">= ₹{(parseFloat(p.monthly || 0) * 12).toLocaleString("en-IN")} per employee / year</div>
          </div>
        ))}
      </div>
      <Button disabled={busy} onClick={save} className="mt-5 bg-[#0D5C3A] hover:bg-[#084229]" data-testid="admin-plans-save-btn">Save pricing</Button>
    </div>
  );
}
